import { HOME_BROWSE_PATH } from '../../constants/paths';
import isDesktop from '../desktop/isDesktop';

export default function unauthRedirectHandler() {
  return { pathname: isDesktop() ? HOME_BROWSE_PATH : '/' };
}
